import moment from "moment";

export default {
  entityName: "lost",
  upsert: "full",
  filterStorage: {},
  pagination: {
    rowsPerPage: 10,
    page: 1,
    sortBy: "id",
    descending: true,
  },
  fields: [
    // ── Lost Date ─────────────────────────────────────────────────────────────
    {
      value: "lost_date",
      text: "Lost Date",
      type: "date",
      table: { sortable: true, filter: true },
      filtertofrom: true,
      render: (item) =>
        item.lost_date ? moment(item.lost_date).format("YYYY-MM-DD") : "",
    },

    // ── Protocol ──────────────────────────────────────────────────────────────
    {
      value: "protocol_id",
      text: "Protocol",
      type: "autocomplete",
      title: "name",
      table: { sortable: true, filter: true },
      render: (item) => (item.protocol && item.protocol.name) || "",
    },

    // ── Site ──────────────────────────────────────────────────────────────────
    {
      value: "site_id",
      text: "Site",


      filter: (item, search) => {
        if (!search) return {};
        return [
          { "site.name": `%${search}%` },
          { "site.city": `%${search}%` },
          { "site.code": `%${search}%` },
        ];
      },
      table: { sortable: true, filter: true },
      render: (item) =>
        item.site ? `${item.site.city} – ${item.site.name}` : "",
    },

    // ── Site Req/Ret ──────────────────────────────────────────────────────────
    {
      value: "type",
      text: "Site Req/Ret",
      type: "list",
      list: [
        { value: "request", text: "Request" },
        { value: "return", text: "Return" },
      ],
      'item-title': 'text',
      table: { sortable: true, filter: true },
      render: (item) => {
        if (!item.type || !item.type_id) return item.type || "-";
        const isRequest = item.type === "request";
        const label = isRequest ? "Site Request" : "Site Return";
        const color = isRequest ? "#1976D2" : "#00897B";
        const path = isRequest
          ? `#/siterequest/${item.type_id}`
          : `#/returned/${item.type_id}`;
        return (
          `<a href="${path}" target="_blank" style="text-decoration:none">` +
          `<span style="display:inline-block;padding:2px 10px;border-radius:12px;` +
          `font-size:12px;color:#fff;background:${color};white-space:nowrap">` +
          `${label}</span></a>`
        );
      },
      readonly: (item) => !!item.id,
    },

    // ── Drugs (nomi + n_pieces) ────────────────────────────────────────────────────
    {
      value: "drugs",
      text: "Drugs",
      readonly: true,
      table: { sortable: false, filter: false },
      visible: false,
      render: (item) => {
        if (!item.drugs || !item.drugs.length) return "-";

        // Mappa drug_id → dati farmaco da lost_drugs
        const drugMap = {};
        if (item.lost_drugs) {
          item.lost_drugs.forEach((d) => {
            drugMap[d.id] = d;
          });
        }

        // Raggruppa per drug_id sommando le n_pieces (un farmaco può avere più lotti)
        const grouped = {};
        item.drugs.forEach((d) => {
          const key = d.drug_id;
          if (!grouped[key]) {
            grouped[key] = { drug: drugMap[d.drug_id], n_pieces: 0 };
          }
          grouped[key].n_pieces += Number(d.n_pieces) || 0;
        });

        const lines = Object.values(grouped)
          .filter(({ drug }) => drug)
          .map(({ drug, n_pieces }) => {
            const dose =
              drug.dose && drug.measure_unit
                ? ` ${drug.dose} ${drug.measure_unit}`
                : "";
            return `<div style="white-space:nowrap">${drug.name}${dose} &times; <strong>${n_pieces}</strong></div>`;
          });

        return lines.length ? lines.join("") : "-";
      },
    },

    // ── Campi non visibili in tabella (usati nell'upsert/form) ────────────────
    {
      value: "type_id",
      text: "Ref ID",
      type: "text",
      visible: false,
    },
    {
      value: "_filename",
      text: "Lost documentation",
      type: "file",
      visible: (item, state) =>
        !!(item.id && ["Administrator", "EMN User"].includes(state.user.role)),
    },
    {
      value: "filename",
      text: "Filename",
      visible: false,
    },
  ],
  actions: ["upsert", "audit", "download", "remove"],
};
